'use client';

import { useCallback } from 'react';
import { useGlobalContext } from '~/context/vm/GlobalContext';
import useGetFetchGeocode from '~/hooks/vm/useGetGeocode';
import HeroImageWrapper from './HeroImage';

export default function Hero() {
  const { currentZip, mapWrapperRef, setCurrentZip } = useGlobalContext();
  const fetchGeocode = useGetFetchGeocode();

  const scrollToMap = useCallback(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: mapWrapperRef.current?.offsetTop ?? 0
    });
  }, [mapWrapperRef]);

  return (
    <HeroImageWrapper
      currentZip={currentZip}
      onZipChange={setCurrentZip}
      onSubmit={() => {
        scrollToMap();
        fetchGeocode();
      }}
    />
  );
}
